import Image, { ImageProps } from 'next/image';
import { twMerge } from 'tailwind-merge';

type AccentImageProps = ImageProps & {
  className?: string;
  fetchPriority?: 'high' | 'low' | 'auto';
  sizes?: string;
};

export const AccentImage = ({ src, alt, className, fetchPriority, sizes, ...props }: AccentImageProps) => (
  <div className='group/accent-image relative h-full w-full after:absolute after:content-[""] after:bottom-0 after:left-0 after:-z-10 after:bg-transparent after:border-2 after:border-neutral-800 after:w-[98%] after:h-[98%] after:-translate-x-2 after:translate-y-2 after:rounded-xl after:shadow-md after:transition-all after:duration-300 hover:after:border-action/30'>
    <div className="relative h-full w-full overflow-hidden rounded-xl">
      <Image
        src={src}
        alt={alt}
        className={twMerge('w-full h-full object-cover shadow-2xl rounded-xl transition-transform duration-500 group-hover/accent-image:scale-105', className)}
        fetchPriority={fetchPriority}
        sizes={sizes}
        {...props}
      />
      {/* Subtle gradient overlay on hover */}
      <div className="absolute inset-0 bg-gradient-to-t from-background/20 to-transparent opacity-0 group-hover/accent-image:opacity-100 transition-opacity duration-300 pointer-events-none rounded-xl" />
    </div>
  </div>
);
